import React, { ReactNode } from "react";
import styled from "styled-components";
import { Link } from "../link";

const Content = styled.div<Props>`
  width: 100%;
  height: 100%;
  display: block;
  background: ${(props) =>
    props.bg ? props.theme.colors[props.bg] : props.theme.colors.smoke};
  padding: ${(props) => {
    if (!props.to) {
      return props.padding || "35px 30px"
    }
  }};
  a {
    text-decoration: none;
    transition: all 0.2s ease-in;
    color: ${(props) => props.color ? props.theme.colors[props.color] : ""};
    padding: ${(props) => {
    if (props.to) {
      return props.padding || "35px 30px"
    }
  }};
    width: 100%;
    height: 100%;
    &:focus {
      background: ${(props) => (props.to ? props.theme.colors.monteCarlo : "")};
      color: ${(props) => (props.to ? "white" : "")};
    }
    &:hover {
      background: ${(props) => (props.to ? props.theme.colors.monteCarlo : "")};
      color: ${(props) => (props.to ? "white" : "")};
    }
  }
  a p.subTitle {
    text-decoration: underline;
  }
`;

const Card: React.FC<Props> = ({
  children,
  bg,
  padding,
  color,
  target,
  to,
}) => {
  if (to) {
    return (
      <Content padding={padding} color={color} to={to} bg={bg}>
        <Link to={to} target={target}>
          {children}
        </Link>
      </Content>
    );
  } else {
    return (
      <Content padding={padding} color={color} bg={bg}>
        {children}
      </Content>
    )
  }
};

export { Card };

export interface Props {
  bg?: string;
  to?: string;
  target?: string;
  padding?: string;
  color?: string;
  children: ReactNode;
}
